<template>
    <div class="home__nav-item-icon">
        <img class="home__nav-item-icon-img" v-if="!isStrEmpty(icon)" :src="require(`@/public/img/${$store.state.config.skin}/${icon}.png`)" />
        {{ getTranslatedText(name) }}
    </div>
</template>
<script>
import languageMixins from '@/mixins/language-mixins';
import utilsMixin from '@/mixins/function-utils';

export default {
    mixins: [languageMixins, utilsMixin],

    props: {
        icon: {
            type: String,
            default: '',
        },
        name: {
            type: String,
            default: '',
        },
    },
    data() {
        return {};
    },
    methods: {},
};
</script>
